import React from 'react'
import styled from 'styled-components'
import intro from '../../images/gamification/intro.png'
import bg from '../../images/gamification/bg.png'
import banner from '../../images/gamification/event_banner.png'
import { SIZES } from '../../styles/theme'
import title from '../../images/gamification/TOKEN_HUNTER.png'

const Wrapper = styled.div`
  position: relative;
  .intro-text {
    position: absolute;
    top: 38%;
    left: 50%;
    right: -19%;
    transform: translate(-50%, -50%);
    color: white;
    font-weight: bold;
    text-shadow: 0px 3px 6px #00000085;
    text-align: center;
    font-size: 1.5rem;
  }

  button {
    position: absolute;
    bottom: 5%;
    left: 50%;
    font-weight: 500;
    transform: translateX(-50%);
  }
  .banner {
    visibility: hidden;
    display: none;
  }
  ${SIZES.mobile} {
    .intro-text {
      right: -42%;
    }

    width: 100%;
    min-height: 350px;
    background: url(${intro});
    background-repeat: no-repeat;
    background-size: 175%;
    background-position: center top;
    #intro {
      display: none;
    }
    .banner {
      display: block;
      margin: 0 auto;
      padding: 18px 8px;
      padding-bottom: 0;
    }
    button.start-button {
      position: static;
      transform: none;
      max-width: 500px;
    }
  }
`

function IntroTab({ setTab }) {
  return (
    <Wrapper>
      <img id="intro" src={intro} width="100%" alt="lucky draw introduction" />
      <p className="intro-text">
        RM 1000 Cash Giveaway
        <br />
        <br />
        Collect 160 points to enter the lucky draw now!
      </p>
      <img className="banner" src={banner} width="85%" alt="event name" />
      <img className="banner p-0" src={title} width="65%" alt="lucky draw" />
      <button onClick={()=>setTab("How To Play")} className="start-button">START PLAYING</button>
    </Wrapper>
  )
}

export { IntroTab }
